import { render, staticRenderFns } from "./InstagramChannels.vue?vue&type=template&id=4df02bf6&scoped=true"
import script from "./InstagramChannels.vue?vue&type=script&lang=js"
export * from "./InstagramChannels.vue?vue&type=script&lang=js"
import style0 from "./InstagramChannels.vue?vue&type=style&index=0&id=4df02bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df02bf6",
  null
  
)

export default component.exports